import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';

import * as React from 'react';
import ReactDOM from 'react-dom';
import { StyleBaseline } from '@alinta-digital/asg';
import GlobalStyle from './GlobalStyle';
import App from './App';
import { GlobalStyleV2 } from '@alinta-digital/myaccount-frontend-shared';

// const basename = process.env.REACT_APP_HOSTED_PATH || '';

ReactDOM.render(
  <>
    <StyleBaseline />
    <GlobalStyle />
    <GlobalStyleV2 />
    <App />
  </>,
  document.getElementById('root')
);
